import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const NoViewsAvailable = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.MainContainer>
      <img src="/icons/cross.png" alt="" />
      <Styles.TextsContainer>
        <Text type="titleM" color={theme.colors.text.subtle}>
          {t('No hay ninguna vista disponible para este grupo')}
        </Text>
        <Text type="bodyMRegular" color={theme.colors.text.muted}>
          {t('Por favor, contacta con tu administrador')}
        </Text>
      </Styles.TextsContainer>
    </Styles.MainContainer>
  )
}

export default NoViewsAvailable
